import TechniquesService from '@/services/codebooks/TechniquesService'

export default {
  namespaced: true,
  state: {
    techniquesList: []
  },
  getters: {
    techniquesList: state => state.techniquesList
  },
  actions: {
    refreshTechniques ({ commit }) {
      return TechniquesService.getAllTechniques()
        .then(list => {
          commit('SET_TECHNIQUES', list)
        })
    },
    addNewTechnique ({ commit }, technique) {
      return TechniquesService.saveTechnique(technique).then(result => {
        technique.id = result.data
        commit('ADD_TECHNIQUE', technique)
        return technique
      })
    },
    editTechnique ({ commit }, technique) {
      return TechniquesService.saveTechnique(technique).then(result => {
        commit('EDIT_TECHNIQUE', technique)
        return technique
      })
    },
    deleteTechnique ({ commit }, technique) {
      return TechniquesService.removeTechnique(technique).then(result => {
        commit('DELETE_TECHNIQUE', technique)
      })
    }
  },
  mutations: {
    SET_TECHNIQUES (state, list) {
      state.techniquesList = list
    },
    EDIT_TECHNIQUE (state, technique) {
      const current = state.techniquesList[technique.index]
      current.name = technique.name
    },
    ADD_TECHNIQUE (state, technique) {
      const newTechnique = {
        id: technique.id,
        name: technique.name
      }
      state.techniquesList.push(newTechnique)
    },
    DELETE_TECHNIQUE (state, technique) {
      state.techniquesList.splice(technique.index, 1)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/codebook/techniques.js